const Chat = () => {
    return (
        <div className="flex flex-col h-full p-3">
            {/* 상대방 메시지 */}
            <img
                src="/assets/profile-souta.png"
                alt="프로필"
                className="w-[20%] pb-2 rounded-full object-cover self-start"
            />
            <div className="max-w-[100%] ml-3 mb-2 p-2 rounded-lg bg-blue-500 text-white self-start" style={{ fontSize: '0.8vw' }}>
                어때~? 많이 늘었지?!
            </div>

            {/* 내 메시지 */}
            <img
                src="/assets/profile-hoshi.png"
                alt="프로필"
                className="w-[20%] pb-2 -mt-[2vw] rounded-full object-cover self-end"
            />
            <div className="max-w-[100%] mr-3 mb-2 p-2 rounded-lg bg-blue-500 text-white self-end" style={{ fontSize: '0.8vw' }}>
                소우타~ 실력 많이 늘었는데?
            </div>
        </div>
    );
};

export default Chat;
